<template lang="html">
  <div class="animated fadeIn">
    <b-card>
      <b-button-toolbar class="pull-right">
        <b-btn variant="primary" @click="showAddCategory">Add Category</b-btn>
      </b-button-toolbar>
    </b-card>

    <b-card>
      <v-client-table :columns="columns" :data="categories" :options="options" :theme="theme" id="dataTable" ref="dataTable">
        <template slot="isEnabled" slot-scope="data">
          {{getIsEnabledLable(data.row)}}
        </template>
        <template slot="ismain" slot-scope="data">
          {{getIsCatalougeLable(data.row)}}
        </template>

        <template slot="actions" slot-scope="data">
          <b-btn size="sm" variant="outline-primary" @click="showEditCategory(data.row)" class="mr-1">Edit</b-btn>
        </template>
      </v-client-table>
    </b-card>
    <div>
      <b-modal ref="modalEditCategory" title="Edit Category" hide-footer @hide="hideEditCategory">
        <category-edit v-if="selectedCategory" :showMeal="showMeal" :showPrasad="showPrasad" :showBhaint="showBhaint" :systemid="systemid" :selectedCategory="selectedCategory" @success="editCategorySuccess" @cancel="cancelEditCategory" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalAddCategory" title="Add Category" hide-footer >
        <category-add :showMeal="showMeal" :showPrasad="showPrasad" :showBhaint="showBhaint" @success="addCategorySuccess" @cancel="cancelAddCategory" :systemid="systemid" />
      </b-modal>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Vue from 'vue'
  import CategoryEdit from './CategoryEdit'
  import CategoryAdd from './CategoryAdd'
  import filter from 'lodash/filter'


  export default {
    name: 'CategoryList',
    props: {
      systemid: {
        type: Number,
        default: null,
      },
      showMeal: {
        type: Boolean,
        defalut: false
      },
      showPrasad: {
        type: Boolean,
        defalut: false
      },
      showBhaint: {
        type: Boolean,
        defalut: false
      }
    },
    components: {
      CategoryEdit,
      CategoryAdd
    },

    data: function() {
      return {

        selectedCategory: Object,
        columns: ['name', 'ismain', 'isEnabled', 'actions'],
        options: {
          headings: {
            id: 'Name',
            ismain: 'Show in Catalouge',
            isEnabled: 'Enabled?'
          },
          sortable: ['name'],
          filterable: ['name', 'ismain'],
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          pagination: {
            chunk: 5,
            edge: true,
            nav: 'scroll'
          },
          perPage: 25,

        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
      }
    },
    computed: {
      categories(){
        let systemid = this.systemid;
        return filter(this.$store.state.pos.categories,
           function(cat) {
             return (cat.systemid == systemid);
        });
      }
    },
    methods: {
      showAddCategory(){
        this.$refs.modalAddCategory.show();
      },
      cancelAddCategory() {
        this.$refs.modalAddCategory.hide()
      },
      addCategorySuccess(category) {
        this.$refs.modalAddCategory.hide();        
        this.$store.dispatch('pos/getCategories')
      },
      getIsEnabledLable(category){
         return category.isEnabled == 1 ? 'Yes' : 'No';
      },
      getIsCatalougeLable(category){
         return category.ismain == 1 ? 'Yes' : 'No';
      },
      showEditCategory(category) {
        this.selectedCategory = category
        this.$refs.modalEditCategory.show()
      },
      cancelEditCategory() {
        this.$refs.modalEditCategory.hide()
      },
      editCategorySuccess() {
        this.$refs.modalEditCategory.hide();
        this.$store.dispatch('pos/getCategories')
      },
      hideEditCategory() {
        this.selectedCategory = null
      },
    },
    created() {
      if (this.$store.state.pos.categories.length == 0) {
        this.$store.dispatch('pos/getCategories');
      }
    }
  }
</script>

<style lang="css">
</style>
